import { useWindowSize } from '@hooks/useWindowSize';
import IconSearch from './search-button.svg';

import styles from './SearchButton.module.scss';

export const SearchButton = (): JSX.Element => {
  const [width] = useWindowSize();
  const isBrowser = typeof window === 'object';
  const isDesktop = isBrowser && width > 990;
  // *IOS hack for diginetica*
  const ClickSearchDigineticaIos = () => {
    document.querySelector('button.search-form__input')?.dispatchEvent(new Event('focus'));
  };

  const ClickSearchDiginetica = () => {
    if (isBrowser && isDesktop) {
      window.scrollTo(0, 0);
      setTimeout(() => {
        const el = document.querySelector('#inputSearchDiginetica');
        if (el) {
          el.dispatchEvent(new Event('focus'));
          el.dispatchEvent(new Event('select'));
        }
      }, 500);
    }
  };

  return (
    <div className={styles.Container} onClick={() => ClickSearchDigineticaIos()}>
      <button onClick={() => ClickSearchDiginetica()} type="button" aria-label="поиск" className={!isDesktop ? ' search-form__input' : ''}>
        <IconSearch />
      </button>
    </div>
  );
};
